/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBookedShiftOutput } from "../../entities/models/BookedShiftOutput";
import { z } from "zod/v4";

export const modelsBookedShiftOutputSchema = z.object({
    "can_start": z.optional(z.boolean()),
"end_time": z.optional(z.string()),
"shift_id": z.optional(z.int()),
"start_time": z.optional(z.string()),
"station_id": z.optional(z.int()),
"station_name": z.optional(z.string()),
"status": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBookedShiftOutput>